const billing = {
	invoices: {
		invoice_dialog: {
			actions: {
				download: "Download",
				pay: "Betalen",
			},
			invoice_date: "Factuurdatum",
			pay_before: "Te betalen voor",
			status: "Status",
			table: {
				date: "Datum",
				description: "Omschrijving",
				price: "Bedrag excl. BTW",
				quantity: "Aantal",
				total_row: {
					price_with_vat: "Bedrag incl. BTW €",
					price_without_vat: "Bedrag excl. BTW €",
					vat_percentage: "21% BTW €",
				},
			},
		},
		title: "Facturen",
	},
	orders: {
		table: {
			company: "Bedrijf",
			debtor_code: "Debiteurnummer",
			free: "Gratis",
			order_date: "Datum Aangemaakt",
			order_label: "Label",
			order_number: "Order nummer",
			order_status: "Order status",
			order_type: {
				dadup: "daDup",
				domain: "Domeinnamen",
				label: "Producten",
				pbs: "PBS",
				pbs_free: "PBS gratis",
				pbs_sync: "PBS sync",
				qemu: "VPS",
			},
			other: "Overige",
			reset: "Reset",
			search: "Zoeken",
			status: {
				active: "Actief",
				cancellation_pending: "Annulering in behandeling",
				cancelled: "Opgezegd",
				completed: "Geslaagd",
				ended: "Beëindigd",
				failed: "Mislukt",
				label: "Statussen",
				pending: "In afwachting",
				replaced: "Vervangen",
			},
			sub_row: {
				alert_description:
					'Deze dienst wordt achteraf gefactureerd. Klik aan de rechterkant op "bekijken" voor uw actuele gebruik.',
				expired_at: "Verlopen op",
				order_done_by: "Order gedaan door",
				order_purchase_number: "inkoopordernummer",
				price: "Bedrag excl. BTW",
				product: "Product",
				quantity: "Aantal",
				replaced_by_order: "Vervangen door order",
				replaces_order: "Vervangt order",
				title: "Order",
				unit: {
					mb: "MB",
					unit_month: "maand",
					x: "X",
				},
			},
			total_price: "Totaalbedrag",
		},
	},
};

export default billing;
